import React from 'react';

import {listPageClassName} from 'shared/ui/ListPage/ListPage';

import {MainLayout} from 'widgets/layout';

import {PortIncidentsScreen} from 'features/port';

const PortIncidentsPage: React.FC = () => {
    return (
        <MainLayout className={listPageClassName}>
            <PortIncidentsScreen />
        </MainLayout>
    );
};

export default PortIncidentsPage;
